import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {categories.map((category) => (
        <Link
          key={category.key}
          to={category.path}
          className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50 md:p-5"
        >
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 md:h-16 md:w-16">
            <i className={`${category.icon} text-2xl md:text-3xl`}></i>
          </span>
          <span className="min-w-0">
            <span className="flex items-center gap-1 text-base font-semibold text-foreground-900">
              {category.name}
              <i className="ri-arrow-right-s-line text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600"></i>
            </span>
            <span className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">
              {category.description}
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}